<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>服务力配置 - 服务项管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <!-- 查询 -->
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item label="技能名称">
          <el-input v-model="serviceQuery.itemName" clearable></el-input>
        </el-form-item>
        <!-- <el-form-item label="对应技能">
          <el-select v-model="serviceQuery.itemSkill" filterable clearable multiple>
            <el-option label="全部" value></el-option>
            <el-option
              v-for="item in skillNameList"
              :key="item.id"
              :label="item.skillName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="状态">
          <el-select v-model="serviceQuery.state" placeholder clearable>
            <el-option label="全部" value></el-option>
            <el-option label="正常" value="0"></el-option>
            <el-option label="停用" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-button icon="el-icon-search" type="primary" plan @click="listQuery">查询</el-button>
   <el-button @click="resetQuery">重置</el-button>

 
      </el-form>
      <!-- 新增 -->
      <el-row class="btn-margin">
        <el-button icon="el-icon-plus"   v-per="'addfuwuxiang'" type="primary" plan @click="addVisible = true">新增服务项</el-button>
              <el-button type="primary"  v-per="'addfuwuxiang'"  icon="el-icon-aim" plan @click="batchSerSkill">批量设置服务者技能</el-button>
      </el-row>
      <!-- 列表数据 -->
      <el-table :data="serviceItemData" border class="table">
        <el-table-column type="index" width="55" label="序号"></el-table-column>
            <el-table-column  width="55" label="技能id" prop="id"></el-table-column>
        <el-table-column prop="itemName" label="技能名称"></el-table-column>
        <el-table-column prop="itemImg" label="关联打卡图片"></el-table-column>
        <!-- <el-table-column prop="skillName" label="对应技能"></el-table-column> -->
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.state == 0">正常</span>
            <span v-if="scope.row.state == 1">停用</span>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateFormat"></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormat"></el-table-column>
        <!-- <el-table-column prop="remark" label="备注"></el-table-column> -->
        <el-table-column prop label="操作">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="editserviceItemBtn(scope.$index,scope.row)">编辑</el-button>
            <el-button
              type="text"
              v-if="scope.row.state == 1"
              @click="useServiceItemBtn(scope.$index,scope.row)"
            >启用</el-button> -->
             <el-button
              type="text"
              v-if="scope.row.state == 0" 
              @click="editItemImg(scope.row)"
            >编辑打卡图片</el-button>
            <el-button
              type="text"
              v-if="scope.row.state == 0"
               v-per="'addfuwuxiang'"
              @click="editserviceItemBtn(scope.$index,scope.row)"
            >设置服务者技能</el-button>
             <el-button
              type="text"
              class="textWarning"
              v-if="scope.row.state == 0"
              @click="deleteServiceItemBtn(scope.$index,scope.row)"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="listQuery"
      />

      <!-- 新增服务项 -->
      <el-dialog title="新增服务项" :visible.sync="addVisible" width="500px" center>
        <el-form
          :rules="rules"
          ref="addServiceItemForm"
          :model="addServiceItemForm"
          class="demo-form-inline"
          label-width="120px"
        >
          <el-form-item label="技能名称" prop="ItemName">
            <el-input v-model="addServiceItemForm.ItemName" clearable class="input-width"></el-input>
          </el-form-item>
        <el-form-item label="对应打卡图片" prop="imgIds" multiple>
            <el-select
              v-model="addServiceItemForm.imgIds"
              multiple
              placeholder
              filterable
              clearable
            >
              <el-option
                v-for="item in imgList"
                :key="item.id"
                :label="item.imgName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>  
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelAddServiceItem('addServiceItemForm')">取 消</el-button>
          <el-button type="primary" plan @click="confServiceItem('addServiceItemForm')">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 编辑服务项 -->
      <el-dialog title="设置服务者技能" :visible.sync="editVisible" width="500px" center>
        <el-form
          :rules="rules"
          ref="editServiceItemForm"
          :model="editServiceItemForm"
          class="demo-form-inline"
          label-width="120px"
        >
          <el-form-item label="服务者" prop="workerIds">
          <el-select v-model="editServiceItemForm.workerIds" multiple placeholder >
            <el-option value label="请选择"></el-option>
            <el-option
              v-for="item in stationlist"
              :key="item.id"
              :label="item.stationName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
 
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editVisible = false">取 消</el-button>
          <el-button type="primary" plan @click="confEditServiceItem('editServiceItemForm')">确 定</el-button>
        </span>
      </el-dialog>

       <!-- 批量设置服务者技能 -->
      <el-dialog :title="dialogTitle" :visible.sync="batchSerSkillVisible" width="500px" center>
        <el-form
          :rules="batchSerSkillRules"
          ref="batchSerSkillForm"
          :model="batchSerSkillForm"
          class="demo-form-inline"
          label-width="120px"
        >
           <el-form-item label="所属城市"  prop="sourceCity">
          <el-select
            placeholder="请选择"
            @change="selectStationByCity"
            v-model="batchSerSkillForm.sourceCity"
            width="100px"
          >
            <!-- <el-option label="全部" value></el-option> -->
            <el-option
              v-for="item in citylist"
              :key="item.id"
              :label="item.cityName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="服务站" prop="servieceStation">
          <el-select v-model="batchSerSkillForm.servieceStation" 
          placeholder width="100px"  @change="selectWorkerByStation" filterable>
            <!-- <el-option value label="请选择"></el-option> -->
            <el-option
              v-for="item in stationlist"
              :key="item.id"
              :label="item.stationName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="服务者" prop="workerIds">
          <el-select v-model="batchSerSkillForm.workerIds" filterable multiple placeholder width="200px">
            <!-- <el-option value label="请选择"></el-option> -->
            <el-option
              v-for="item in workerList"
              :key="item.id"
              :label="item.workerName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
      
          <el-form-item label="对应技能" prop="itemSkill" v-if="isBatchSet">
            <el-select
              v-model="batchSerSkillForm.itemSkill"
              multiple
              placeholder
              filterable
              clearable
            >
              <el-option
                v-for="item in skillNameList"
                :key="item.id"
                :label="item.itemName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="cancelSerSkillItem('batchSerSkillForm')">取 消</el-button>
          <el-button type="primary" plan @click="confSerSkillItem('batchSerSkillForm')">确 定</el-button>
        </span>
      </el-dialog>

      <el-dialog title="编辑服务项对应打卡图片" :visible.sync="editItemImgVisible" width="500px" center>
        <el-form 
          ref="editItemImgForm" 
          class="demo-form-inline"
          label-width="120px"
        >
           <el-form-item label="对应打卡图片" prop="imgIds" multiple>
            <el-select
              v-model="editItemImgForm.imgIds"
              multiple
              placeholder
              filterable
              clearable
            >
              <el-option
                v-for="item in imgList"
                :key="item.id"
                :label="item.imgName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editItemImgVisible = false">取 消</el-button>
          <el-button type="primary" plan @click="confEditItemImg('editItemImgForm')">确 定</el-button>  
        </span>
      </el-dialog>

    </div>
  </div>
</template>
<script>
import moment from "moment";
import "./css/index.css";
import serviceAbility from "@/script/api/serviceAbility";
import Pagination from "@/components/common/Pagination";
import globalData from "@/components/common/globaldata/global.data";
import { update } from "lodash";
export default {
  components: { Pagination },
  data() {
    return {
      rowSkillId:'',
      workerList:[],
      dialogTitle:'批量设置服务者技能',
      isBatchSet:true,
       citylist:[], 
      stationlist:[],
      batchSerSkillVisible:false,
      showWordLimit: true,
      delServiceItemName: "",
      addVisible: false,
      editVisible: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      serviceQuery: {
        itemName: "",
        state: "",
        itemSkill: ""
      },
      skillNameList: [],
      imgList: [],
      serviceItemName: "",
      serviceItem: [],
      serviceItemData: [],
      addServiceItemForm: {
        ItemName: "",
        imgIds: [],
        // remark: "",
        // state: ""
      },
      editServiceItemForm: {
         sourceCity:'',
        servieceStation:'',
        workerIds:[],

      },
      batchSerSkillForm:{
        sourceCity:'',
        servieceStation:'',
        workerIds:[],
        itemSkill:[]
      },
      editItemImgVisible:false,
      editItemImgForm:{
        id:'',
        imgIds: [],
      },
      rules: {
        ItemName: [
          { required: true, message: "请填写服务项名称", trigger: "blur" }
        ],
        // imgIds: [{ required: true, message: "请选择对应打卡图片", trigger: "change" }],
       
      },
      batchSerSkillRules:{
         sourceCity: [
          { required: true, message: "请选择所属城市", trigger: "change" }
        ],
         servieceStation: [
          { required: true, message: "请选择服务站", trigger: "change" }
        ],
        workerIds:[
          { required: true, message: "请选择服务者", trigger: "change" }
        ],
         itemSkill: [
          { required: true, message: "请选择对应技能", trigger: "change" }
        ],
      }
    };
  },
  created() {
    this.listQuery();
    this.getSkillData();
    this.getCityListData();
    this.getAllStation();
    this.getImgListData();
  },
  methods: {
    confEditItemImg(){
      // if(this.editItemImgForm.imgIds.length==0){
      //   this.$message.warning("请选择对应打卡图片");
      //   return;
      // }
      serviceAbility
            .$ajaxserviceItemUpdateItemImg(this.editItemImgForm)
            .then(res => {
              console.log(res);
              if (res.data.errno == 0) {
                this.$message.success("修改服务项打卡图片成功！");
                this.listQuery();
                this.editItemImgVisible = false;
              } else {
                this.$message.warning(res.data.data);
              } 
            })
            .catch(err => {
              console.log(err);
            });
    },
    editItemImg(row){
      this.editItemImgForm.id = row.id;
      this.editItemImgForm.imgIds = row.imgIds;
      this.editItemImgVisible = true;
    },
    getImgListData() {
      serviceAbility
        .$ajaxserviceItemGetAllImgs()
        .then(res => {
          this.imgList = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //重置
    resetQuery() {
      this.serviceQuery.itemName = "";
      // this.serviceQuery.itemSkill = "";
      this.serviceQuery.state = "";
      this.currentPage=1;
      this.listQuery();
    },
    //查询
    listQuery() {
      let temp = {
        pageNum: this.currentPage,
        pageSize: this.pageSize
      };
      if (
        this.serviceQuery.itemName != "" &&
        this.serviceQuery.itemName != undefined
      ) {
        temp.itemName = this.serviceQuery.itemName;
      }
      // if (
      //   this.serviceQuery.itemSkill != "" &&
      //   this.serviceQuery.itemSkill != undefined
      // ) {
      //   temp.itemSkill = this.serviceQuery.itemSkill.join(",");
      // }
      if (
        this.serviceQuery.state != "" &&
        this.serviceQuery.state != undefined
      ) {
        temp.state = Number(this.serviceQuery.state);
      }

      serviceAbility
        .$ajaxSelectServiceItemByPage(temp)
        .then(res => {
          console.log(res);
          this.serviceItemData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    cancelAddServiceItem(addServiceItemForm) {
      this.addVisible = false;
      this.$nextTick(() => {
        this.$refs[addServiceItemForm].resetFields();
      });
    },
 
    //确定新增
    confServiceItem(addServiceItemForm) {
      this.$refs[addServiceItemForm].validate(valid => {
        if (valid) {
          serviceAbility
            .$ajaxAddServiceItem({ 
              itemName: this.addServiceItemForm.ItemName,
              imgIds: this.addServiceItemForm.imgIds,
              state:0
            })
            .then(res => {
              console.log(res);
              if (res.data.errno == 0) {
                this.$message.success("新增服务项成功！");
                this.listQuery();
                this.addVisible = false;
              } else {
                this.$message.warning(res.data.data);
              }
              //请缓存
              this.addServiceItemForm.ItemName = "";
              this.addServiceItemForm.imgIds = [];
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 启用
    useServiceItemBtn(index, row) {
      // console.log(row.state);
      this.$confirm("您确定启用服务项  " + row.itemName + "  吗？")
        .then(_ => {
          this.confUesService(row.id);
        })
        .catch(_ => {});
    },

    confUesService(id) {
      operationManage
        .$ajaxUpdateServiceItemState({
          id: id,
          state: 0
        })
        .then(res => {
          console.log(res);
          if (res.data.errno == 0) {
            this.$message.success("服务项启用成功");
            this.listQuery();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    // 删除
    deleteServiceItemBtn(index, row) {
      this.$confirm("您确定删除服务项  " + row.itemName + "  吗？")
        .then(_ => {
          this.confStopService(row.id);
        })
        .catch(_ => {});
    },

    confStopService(id) {
      serviceAbility
        .$ajaxUpdateServiceItemState({
          id: id,
          state: 1
        })
        .then(res => {
          console.log(res);
          if (res.data.errno == 0) {
            this.$message.success("服务项删除成功");
            this.listQuery();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },

    //编辑
    editserviceItemBtn(index, row) {
       this.batchSerSkillVisible = true;
      this.dialogTitle='设置服务者技能';
      this.isBatchSet=false;
      this.rowSkillId=row.id;
      // this.editServiceItemForm.id = row.id;
      // this.editServiceItemForm.ItemName = row.itemName;
      // this.editServiceItemForm.state = String(row.state);
      // this.editServiceItemForm.itemSkill = row.itemSkill.split(",").map(Number);
    },
    //确定编辑
    confEditServiceItem(editServiceItemForm) {
      this.$refs[editServiceItemForm].validate(valid => {
        if (valid) {
          operationManage
            .$ajaxUpdateServiceItem({
              id: this.editServiceItemForm.id,
              itemName: this.editServiceItemForm.ItemName,
              itemSkill: this.editServiceItemForm.itemSkill.join(","),
              state: Number(this.editServiceItemForm.state)
            })
            .then(res => {
              console.log(res);
              if (res.data.errno == 0) {
                this.$message.success("修改服务项成功！");
                this.listQuery();
                this.editVisible = false;
              }
            })
            .catch(err => {
              console.log(err);
            });
        }
      });
    },
  //获取城市下拉数据
    getCityListData() {
      serviceAbility
        .$ajaxSelectAllCity()
        .then(res => {
          this.citylist = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取技能下拉数据
    getSkillData() {
      serviceAbility
        .$ajaxSelectEmSkillList()
        .then(res => {
          // console.log(res.data.data);
          this.skillNameList = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //时间格式化
    dateFormat(row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm:ss");
    },
    batchSerSkill(){
      this.batchSerSkillVisible = true;
      this.dialogTitle='批量设置服务者技能';
      this.isBatchSet=true;
    },
      //查询驿站
    selectStationByCity(vId) {
      // console.log(vId);
      if(vId==null||vId==""){
        return ;
      }
      serviceAbility
        .$ajaxSelectStation({cityId:vId}).then(res => { 
          this.stationlist = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    getAllStation(){
      serviceAbility
        .$ajaxSelectStation().then(res => { 
          this.stationlist = res.data.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    selectWorkerByStation(id){
      this.batchSerSkillForm.workerIds=[];
      let params={stationId:id};
       serviceAbility
        .$ajaxWorkerListByStage(params)
        .then(res => {
          console.log(res);
          this.workerList = res.data.data;
         
        })
        .catch(err => {
          console.log(err);
        });

    },
     cancelSerSkillItem(formName) {
      this.batchSerSkillVisible = false;
      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
    },
    //确定新增
    confSerSkillItem(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let itemSkill=this.isBatchSet?this.batchSerSkillForm.itemSkill:[this.rowSkillId];
          serviceAbility
            . $ajaxSetServiceWorker({
              skillIds :itemSkill,
              stageId:this.batchSerSkillForm.servieceStation,
              workerIds: this.batchSerSkillForm.workerIds,
              cityId:this.batchSerSkillForm.sourceCity
            })
            .then(res => {
              console.log(res);
              if (res.data.errno == 0) {
                this.$message.success("设置成功！");
                this.listQuery();
                this.batchSerSkillVisible = false;
              } else {
                this.$message.warning(res.data.data);
              }
              //请缓存
              this.batchSerSkillForm.skillIds=[];
              this.batchSerSkillForm.workerIds=[];
            })
            .catch(err => {
              console.log(err);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

  }
};
</script>
<style>
</style>